import { localizeWithPath } from 'monaco-editor/esm/vs/nls.js';
import { createDecorator } from 'monaco-editor/esm/vs/platform/instantiation/common/instantiation.js';
import { Registry } from 'monaco-editor/esm/vs/platform/registry/common/platform.js';
import { workbenchConfigurationNodeBase } from '../../../common/configuration.js';
import { Extensions } from 'monaco-editor/esm/vs/platform/configuration/common/configurationRegistry.js';
const IWorkbenchAssignmentService = ( createDecorator('WorkbenchAssignmentService'));
const registry = ( Registry.as(Extensions.Configuration));
registry.registerConfiguration({
    ...workbenchConfigurationNodeBase,
    'properties': {
        'workbench.enableExperiments': {
            'type': 'boolean',
            'description': ( localizeWithPath(
                'vs/workbench/services/assignment/common/assignmentService',
                'workbench.enableExperiments',
                "Fetches experiments to run from a Microsoft online service."
            )),
            'default': true,
            'scope': 1 ,
            'restricted': true,
            'tags': ['usesOnlineServices']
        }
    }
});
export { IWorkbenchAssignmentService };
